<!-- start banner Area -->
<!-- <section class="banner-area relative"
  id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Nous contacter
        </h1>
        <p class="text-white"><a routerLink="">Accueil </a> <span class="lnr lnr-arrow-right"></span> <a
            routerLink="/contact"> Nous contacter</a></p>
      </div>
    </div>
  </div>
</section> -->
<!-- End banner Area -->

<!-- infos -->
<section class="contact"
  style="background: url('assets/img/mask-back.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; padding: 50px 0px 0px 0px;">
  <div class="container">
    <div class="">
      <div class="row" *ngIf="submenu == 'benin-tpc'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">
            <h4 class="pays"><img src="assets/img/benin.svg">Bénin TPC</h4>
            <hr>
            <p><img src="assets/img/location.svg">C/892-Sikècodji-Fignon Cotonou 01 B.P. 5771 Rép. du Bénin</p>
            <p><img src="assets/img/local-phone.svg">(+229) 21 15 93 17 / 97 64 03 93</p>
            <p><img src="assets/img/email.svg"> <a
                href="mailto:info@talentsplusafrique.com">info@talentsplusafrique.com</a></p>
            <a target="_blank"
              href="https://www.google.com/maps/place/TALENTS+PLUS+AFRIQUE/@6.3767471,2.4151553,17z/data=!3m1!4b1!4m6!3m5!1s0x10235592a0e0a68d:0x505895d3604b2426!8m2!3d6.3767418!4d2.417344!16s%2Fg%2F11g1gq53js?hl=fr">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>

        </div>
      </div>
      <div class="row" *ngIf="submenu == 'benin-ett'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">
            <h4 class="pays"><img src="assets/img/benin.svg">Bénin - ETT</h4>
            <hr>
            <p><img src="assets/img/location.svg">C/892-Sikècodji-Fignon Cotonou 01 B.P. 5771 Rép. du Bénin</p>
            <p><img src="assets/img/local-phone.svg">(+229) 21 15 93 17 / 96 35 77 22</p>
            <p><img src="assets/img/email.svg"> <a
                href="mailto:ett@talentsplusafrique.com">ett@talentsplusafrique.com</a></p>
            <a target="_blank"
              href="https://www.google.com/maps/place/TALENTS+PLUS+AFRIQUE/@6.3767471,2.4151553,17z/data=!3m1!4b1!4m6!3m5!1s0x10235592a0e0a68d:0x505895d3604b2426!8m2!3d6.3767418!4d2.417344!16s%2Fg%2F11g1gq53js?hl=fr">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="submenu == 'cote-d-ivoire'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">
            <h4 class="pays"><img src="assets/img/cote.svg">Côte d’ivoire</h4>
            <hr>
            <p><img src="assets/img/location.svg">Abidjan, Cocody II Plateaux, Blvd des Martyrs, Immeuble BOTIWA, 3è
              étage,
              Appart 531 Abidjan 08 BP 4093 Abidjan 08 Rép. de Côte d'Ivoire</p>
            <p><img src="assets/img/local-phone.svg">(+225) 27 22 41 01 52 / 07 09 21 17 27</p>
            <p><img src="assets/img/email.svg"><a
                href="mailto:infotpc@talentsplusafrique.com">infotpc@talentsplusafrique.com</a></p>
            <a target="_blank"
              href="https://www.google.com/maps/place/5%C2%B022'13.0%22N+3%C2%B059'52.6%22W/@5.370288,-4.0001179,17z/data=!3m1!4b1!4m4!3m3!8m2!3d5.370288!4d-3.9979292?hl=fr">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="submenu == 'togo'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">
            <h4 class="pays"><img src="assets/img/togo.svg">Togo</h4>
            <hr>
            <p><img src="assets/img/location.svg">12 Rue Koumore , Immeuble l'Habitat 1er Étage, Assivito Lomé BP
              13085
              lomé TOGO
              Rép. du Togo</p>
            <p><img src="assets/img/local-phone.svg">(+228) 22 22 91 35 / 90 67 76 88</p>
            <p><img src="assets/img/email.svg"><a
                href="mailto:tptg@talentsplusafrique.com">tptg@talentsplusafrique.com</a></p>
            <a target="_blank" href="">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="submenu == 'mali'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">
            <h4 class="pays"><img src="assets/img/mali.svg">Mali</h4>
            <hr>
            <p><img src="assets/img/location.svg">A.C.I. 2000 HAMDALLAYE Bamako Rép. du Mali</p>
            <p><img src="assets/img/local-phone.svg">(+223) 20 22 36 71</p>
            <p><img src="assets/img/email.svg"><a
                href="mailto:tpcmali@talentsplusafrique.com">tpcmali@talentsplusafrique.com</a></p>
            <a target="_blank" href="">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="submenu == 'gisea-sarl'">
        <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
          <h2 class="customize-title">Contactez-nous</h2>
          <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
            Contactez-nous
            maintenant</p>
        </div>

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="contact-card">

            <p><img src="assets/img/location.svg">Numéro IFU : 3201810249564</p>
            <p><img src="assets/img/location.svg">Numéro RCM : RCCM-RB-COT-18-B-21101</p>
            <p><img src="assets/img/local-phone.svg">(+229) 94 52 17 61</p>
            <p><img src="assets/img/email.svg"><a
                href="mailto:infotpc@talentsplusafrique.com">infotpc@talentsplusafrique.com</a>gisa@talentsplusafrique.com
            </p>
            <a target="_blank"
              href="https://www.google.com/maps/place/GISEA/@6.3771197,2.3920657,15z/data=!4m5!3m4!1s0x0:0x6a7200796fe51d62!8m2!3d6.3771197!4d2.3920657">
              <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
            </a>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" *ngIf="submenu == 'carte'">

        <div class="col-12 col-sm-8 col-lg-8">
          <div class="">
            <img src="assets/img/carte.jpg">
          </div>
          <br> <br>

        </div>
      </div>
    </div>
  </div>
</section>
<section class="form-contact">

  <div class="container">
    <h2 class="customize-title" style="margin-bottom:20px;">Ecrivez-nous</h2>
    <form id="myForm" [formGroup]="contactForm" (ngSubmit)="onSubmitContactForm()">
      <div class="row">
        <div class="mb-3 col-md-6" style="">
          <label class="form-label">Votre nom<span>*</span></label>
          <input type="text" class="form-control" id="name" formControlName="name" placeholder="Nom**">
        </div>
        <div class="mb-3 col-md-6" style="">
          <label class="form-label">Votre email<span>*</span></label>
          <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email**">
        </div>
        <div class="mb-3 col-md-6" style="">
          <label class="form-label">Sujet<span>*</span></label>
          <input type="email" class="form-control" id="subject" formControlName="subject" placeholder="Sujet**">
        </div>

        <div class="mb-3 col-md-12">
          <label for="" class="form-label">Votre message<span>*</span></label>
          <textarea class="form-control" id="task" rows="4" maxlength="300" formControlName="message"
            placeholder="Message**"></textarea>
        </div>
        <div class="mb-3 col-md-12" style="">
          <button type="submit" [disabled]="contactForm.invalid" *ngIf="!formIsLoading"
            class="btn btn-submit">Envoyer</button>
          <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="formIsLoading">Veuillez
            patienter...
          </p>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- 
  <section class="newsletter"
  style="background: url('assets/img/back-news.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-7 col-lg-7">
        <h2>Ne ratez plus rien</h2>
        <p>Abonnez-vous à nos newsletters. Selon vos centres d'intérêts, recevez nos offres d'emplois, nos avis de
          formation, des actualités sur l'entreprise. Abonnez-vous maintenant.</p>
      </div>
      <div class="col-12 col-sm-5 col-lg-5"
        style="margin: auto;">
        <form>

          <div class="mb-3 col-md-12"
            style="padding: 0px !important;">
           
            <input type="email"
              class="form-control"
              id=""
              placeholder="Email">
          </div>
          <div class="mb-3 col-md-12"
            style="padding: 0px !important;">
            <button type="submit"
              class="btn btn-submit-white">Envoyer</button>
          </div>
        </form>

      </div>
    </div>
  </div>
</section> -->


<!-- end infos -->
<!-- Start contact-page Area -->

<!-- End contact-page Area -->